<template>
  <div class="single-question py-16 border-bottom-stroke-dark-soft">
    <div class="grid-row grid-row_md">
      <div class="grid-col grid-col_full">
        <div class="fw-medium">
          {{ questionName }}
        </div>
      </div>

      <div class="grid-col">
        <div class="color-gray">
          {{ questionDate }}
        </div>
      </div>
    </div>

    <div
      class="single-review__text mt-16"
      v-bind:class="{ 'is-show': isActive }"
    >
      <div
        class="color-caption-soft"
        v-html="textCut(questionText, 220)"
        v-show="!isActive"
      ></div>
      <div
        class="color-caption-soft"
        v-html="questionText"
        v-show="isActive"
      ></div>
    </div>

    <!-- если длинный текст -->
    <div class="mt-8" v-if="questionText.length > 220">
      <div class="btn color-tertiary hover-color-dark" @click="toggleState()">
        <span class="d-block" v-if="isActive">Свернуть</span>
        <span class="d-block" v-else>Читать полностью</span>
        <Icon
          iconName="icon-chevron-down"
          className="ml-8 icon-16 active-rotate-180"
          v-bind:class="{ 'is-active': isActive }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "../Icon/Icon.vue";
import { textCut } from "@/pages/product_card/tools/functions";

export default {
  name: "SingleQuestion",
  components: {
    Icon,
  },
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    toggleState() {
      this.isActive = !this.isActive;
    },
    textCut(text, limit) {
      return textCut(text, limit);
    },
  },
  props: {
    questionName: {
      type: String,
      default: "",
    },
    questionDate: {
      type: String,
      default: "",
    },
    questionText: {
      type: String,
      default: "",
    },
  },
};
</script>
